import 'rxjs/add/operator/take';

import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { environment } from '../../../environments/environment';
import { UtilService,LOCAL_VAR } from '@app/core';
import { ToastrService } from 'ngx-toastr';
import { ClaimHelpComponent } from '@app/shared/modals/claim-help/claim-help.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;
  public passwordTextType: boolean;
  loginForm: FormGroup;
  resetPasswordForm: FormGroup;
  isLoading = false;
  isDisable = true;
  isLoading1 = false;
  isLoading2 = false;
  isLoading3 = false;
  counter = 0;
  otpexpire = 300;
  otpsecounts = 0;
  otpResent = 0;
  isEmail = true;
  isMobile = false;
  source: any;
  otpRecieved = false;
  queryParams: any;
  domainconfig:any;
  appname = environment.name;
  applogo = environment.logo;
  logo = environment.logo;
  siteKey = environment.siteKey;
  fileClaim = environment.fileClaim;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaResponse?: string;
  public captchaIsReady = false;

  loginRequest = false;
  requestOTPBy = 'sms';
  credentialError = false;
  
  // public users: any = [
  //   {
  //     email: 'customer@test.com',
  //     password: 'Customer@123',
  //     userType: 'CUSTOMER'
  //   },
  //   { email: 'admin@test.com', password: 'Admin@123', userType: 'ADMIN' }
  // ];
  error: any;
  constructor(
    private modalService: NgbModal,
    public router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private utilService: UtilService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private cdr: ChangeDetectorRef
  ) {
    this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
    });
    this.createForm();
  }

  ngOnInit() { 
    localStorage.setItem(LOCAL_VAR.selectedProduct, 'lease');
    this.domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
    this.applogo = "assets/images/dowc-logo-green-bg.jpg";
    this.logo = "assets/images/dowc-logo.png";
    if (this.domainconfig) {
      if (this.domainconfig.appLogo) {
        this.applogo = this.domainconfig.appLogo;
      }
      if (this.domainconfig.appName) {
        this.appname = this.domainconfig.appName;
      }
      if (this.domainconfig.appLogo) {
        this.logo = this.domainconfig.appLogo;
      }
    }
    this.utilService.clearMissedError();
  }

  ngAfterViewInit() {
    $(function () {
      $('.preloader').fadeOut();
    });

    $('#to-recover').on('click', function () {
      $('#loginform').slideUp();
      $('#recoverform').fadeIn();
    });
    // if(this.applogo==='dowc'){
    //   $('#wrapper').css('background-image', 'url(assets/images/background/dowcgapclaims.jpg)');
    // } else if(this.applogo==='aps'){
    //   $('#wrapper').css('background-image', 'url(assets/images/background/apsgapclaims.jpg)');
    // }
    const head = document.getElementsByTagName('head')[0];
    // const _js = document.createElement('script');
    // _js.type = 'text/javascript';
    // _js.src = 'https://forms.plumsail.com/widget/1.0.8/app.js';
    //head.appendChild(_js);
    // const _js = document.createElement('script');
    // _js.type = 'text/javascript';
    // _js.appendChild(document.createTextNode('var fd = new Plumsail.Form("#claim-form", " 19e08f9f-c19a-4202-9996-78a499af4eae");'));
    // head.appendChild(_js);

    this.utilService.updateDomainCss();
  }

  resetPassword() {
    // TODO: Implement Reset Password
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.pattern(/^(\d{10}|\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])],
      //email: ['', Validators.compose([Validators.required, Validators.email])],
      password: [''],
      code: [
        ''
      ]
    });
    this.resetPasswordForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(/^(\w+([\.+-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3}))$/)])]
    });
  }

  checkInput() {
    if (isNaN(this.loginForm.controls.email.value) && $.trim(this.loginForm.controls.email.value) !== '') {
      this.isEmail = true;
      this.isMobile = false;
      this.otpRecieved = false;
      this.otpResent = 0;
    } else if ($.trim(this.loginForm.controls.email.value) !== '') {
      this.isEmail = false;
      this.isMobile = true;
      this.otpRecieved = false;
      this.loginForm.controls.code.disable();
      this.otpResent = 0;
    } else {
      this.isEmail = false;
      this.isMobile = false;
      this.otpRecieved = false;
      this.otpResent = 0;
    }
    this.checkValidation();
  }

  checkValidation() {
    let value: string = (this.isMobile) ? this.loginForm.controls.code.value : this.loginForm.controls.password.value;
    if ((this.isMobile === true && value.toString().length == 6) || (this.isEmail && value.toString().length > 5)) {
      this.isDisable = false;
    } else {
      this.isDisable = true;
    }
  }

  getCall() {
    this.isLoading3 = true;
    this.loginForm.controls.code.disable();
    let email = this.loginForm.controls.email.value;
    let mode = (this.otpRecieved) ? 'recall' : 'call';
    let payload = {
      phone: email,
      type: mode
    }
    let otpcount = (this.otpRecieved) ? 60 : 30;
    this.authenticationService
      .getotp(payload)
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading3 = false;
        })
      ).subscribe((response: any) => {
        this.otpResent = this.otpResent + 1;
        if (this.otpResent == 1)
          this.OtpExpire();
        if (this.otpResent <= 3)
          this.startCountdown(otpcount);
        this.loginForm.controls.code.enable();
        this.otpRecieved = true;
      });
  }

  loginOld(token:any) {
    this.checkValidation();
    this.isLoading = true;
    // const checkUser = this.users.find((user: any) => {
    //   return (
    //     user.email === this.loginForm.get('_username').value &&
    //     user.password === this.loginForm.get('_password').value
    //   );
    // });
    // if (checkUser !== undefined) {
    //   this.isLoading = false;
    //   localStorage.setItem('isLoogdedin', 'YES');
    //   if (checkUser.userType === 'CUSTOMER') {
    //     localStorage.setItem('userType', 'CUSTOMER');
    //     this.router.navigate(['/claim']);
    //   } else if (checkUser.userType === 'ADMIN') {
    //     localStorage.setItem('userType', 'ADMIN');
    //     this.router.navigate(['/customer']);
    //   } else {
    //     this.error = 'Something went wrong!.';
    //   }
    // } else {
    //   this.isLoading = false;
    //   this.error = 'Email OR Password wrong!. please try again.';
    // }
    if (token) {
      if (this.isMobile) {
        let payload = {
          phone: this.loginForm.controls.email.value,
          code: this.loginForm.controls.code.value,
          token: token
        }
        this.authenticationService
          .otplogin(payload)
          .pipe(
            finalize(() => {
              this.loginForm.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe((credentials: Authentication.Credentials) => {
            this.router.navigate(['/products'], {
              replaceUrl: true
            });
            // if (credentials.user.userRoleId.slug !== 'customer') {
            //   this.router.navigate(['/dashboard'], {
            //     replaceUrl: true
            //   });
            // } else {
            //   this.router.navigate(['/claim'], {
            //     replaceUrl: true
            //   });
            // }
          },
          (error: any) => {
            this.error = error;
            this.reset();
            this.isLoading = false;
          });

      } else {

        let payload = {
          email: this.loginForm.controls.email.value,
          password: this.loginForm.controls.password.value,
          token: token
        }

        this.authenticationService
          .login(payload)
          .pipe(
            finalize(() => {
              this.loginForm.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe((credentials: Authentication.Credentials) => {
            this.router.navigate(['/products'], {
              replaceUrl: true
            });
            // if (credentials.user.userRoleId.slug !== 'customer') {
            //   this.router.navigate(['/dashboard'], {
            //     replaceUrl: true
            //   });
            // } else {
            //   this.router.navigate(['/claim'], {
            //     replaceUrl: true
            //   });
            // }
          },
          (error: any) => {
            this.error = error;
            this.reset();
            this.isLoading = false;
          });

      }
    } else {
      this.reset();
    }

  }

getOTP(token:any) {
    this.isLoading1 = true;
    this.error = null;
    this.loginForm.controls.code.disable();
    // let mode = (this.otpRecieved) ? this.requestOTPBy : 'email';
    let payload = {
      email: this.loginForm.controls.email.value,
      password: this.loginForm.controls.password.value,
      token: token,
      type: this.requestOTPBy
    }
    // let otpcount = (this.otpRecieved) ? 60 : 30;
    this.authenticationService
      .getLoginotp(payload)
      .pipe(
        finalize(() => {
          this.loginForm.markAsPristine();
          this.isLoading = false;
          this.isLoading1 = false;
          if(this.requestOTPBy!='resend') this.reset();
        })
      ).subscribe((response: any) => {
        if(!response.error){
          this.toastrService.info(response.message);
          this.loginRequest = true;
          this.otpResent = this.otpResent + 1;
          if (this.otpResent == 1)
            this.OtpExpire();
          if (this.otpResent <= 3)
            this.startCountdown(60);
          this.loginForm.controls.code.enable();
          this.otpRecieved = true;
        }
      },
      (error: any) => {
        // this.error = error;
        this.reset();
        this.credentialError = this.loginRequest? false: true;
        this.isLoading = false;
      });
  }

  login(token:any) {
    this.credentialError = false;
    // if(this.requestOTPBy=='login')
    //   this.loginOtp(token);
    // else
      this.getOTP(token);
    // this.reset();

  }

  loginOtp(){
    this.isLoading = true;
    this.error ='';
    if(!this.loginForm.controls.code.value){
      this.toastrService.warning('Enter OTP');
      this.reset();
      this.isLoading = false;
      return false;
    }
    // if (token) {
        let payload = {
          email: this.loginForm.controls.email.value,
          code: this.loginForm.controls.code.value
          // token: token
        }
        this.authenticationService
          .loginOtp(payload)
          .pipe(
            finalize(() => {
              this.loginForm.markAsPristine();
              this.isLoading = false;
            })
          )
          .subscribe((credentials: Authentication.Credentials) => {
            this.router.navigate(['/products'], {
              replaceUrl: true
            });
          },
          (error: any) => {
            this.error= error;
            this.reset();
            this.isLoading = false;
          });
    // } else {
    //   this.reset();
    // }

  }

  startCountdown(seconds: number) {
    var counter = seconds;
    this.counter = counter;
    var interval = setInterval(() => {
      this.counter = counter;
      counter--;
      if (counter < 0 || this.otpRecieved == false || this.otpResent > 3) {
        this.counter = 0;
        clearInterval(interval);
      };
    }, 1000);
  }

  OtpExpire() {
    var counter = this.otpexpire;
    this.otpsecounts = counter;
    var interval = setInterval(() => {
      this.otpsecounts = counter;
      counter--;
      if (counter < 0 || this.otpRecieved == false) {
        clearInterval(interval);
      };
    }, 1000);
  }

  reLogin() {
    // location.reload();
    this.loginRequest = false;
    this.otpRecieved = false;
    this.otpResent = 0;
    this.error= '';
    this.reset();
  }

  omit_all_char(event:any)
  {   
     var k;  
     k = event.charCode;  //         k = event.keyCode;  (Both can be used)
     return((k >= 48 && k <= 57)); 
  }

  async openHelpPopup() {
    const modalRef = await this.modalService.open(ClaimHelpComponent);
  }

  handleSuccess(captchaResponse: string): void {
    this.cdr.detectChanges();
    //console.log(captchaResponse);
    if(captchaResponse){
      this.login(captchaResponse)
    }
  }

 execute(): void {
    this.isLoading = true;
    this.requestOTPBy = this.otpRecieved?'login':'sms'; 
   if (this.otpRecieved)
     this.loginOtp();
   else
     this.captchaElem.execute();
    //this.login(true);
  }

  resendSms(){
    this.requestOTPBy = 'resend'; 
    // this.captchaElem.execute();
    this.getOTP(this.requestOTPBy);
  }

  emailOTP(){
    this.requestOTPBy = 'email'; 
    this.captchaElem.execute();
    
  }

  callOTP(){
    this.requestOTPBy = 'call'; 
    this.captchaElem.execute();
  }
 

  reload(): void {
    this.captchaElem.reloadCaptcha();
  }

  reset(): void {
    this.error ='';
    this.captchaElem.resetCaptcha();
    this.reload();
  }

}
